import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router";
import { Button } from "@/components/ui/shadcn/button";
import { hazelWhatsAppUrl, type HazelSubject } from "./hazelWhatsApp";

export function AskHazel({
  subject,
  details,
  request,
  reference,
  appearance = "button",
  label,
}: HazelSubject & {
  appearance?: "button" | "toolbar";
  /**
   * The button's words where it is a step's action ("Request changes" on an
   * addendum draft, design v1); the button appearance only. Absent, it reads
   * "Ask Hazel on WhatsApp".
   */
  label?: string;
}) {
  const location = useLocation();
  const href = hazelWhatsAppUrl({
    subject,
    details,
    request,
    // Only canonical path: don't forward auth tokens or incidental URL state.
    reference: reference ?? `${window.location.origin}${location.pathname}`,
  });
  if (!href) return null;
  if (appearance === "toolbar")
    return (
      <Button
        asChild
        variant="outline"
        className="w-auto shrink-0 gap-2 border-emerald-600/30 bg-emerald-50 px-3 text-emerald-800 hover:bg-emerald-100 hover:text-emerald-900"
      >
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Ask Hazel on WhatsApp"
        >
          <FaWhatsapp aria-hidden="true" className="size-4" />
          Ask Hazel
        </a>
      </Button>
    );
  return (
    <Button asChild variant="outline" className="w-full gap-2 sm:w-auto">
      <a href={href} target="_blank" rel="noopener noreferrer">
        <FaWhatsapp className="size-4" />
        {label ?? "Ask Hazel on WhatsApp"}
      </a>
    </Button>
  );
}
